<template>
  <div>
    <b-row class="mt-3">
      <b-col sm="12">
        <h4 class="mb-3">Detalles del paquete:</h4>
        <b-table-simple bordered small>
          <b-thead>
            <b-tr>
              <b-th class="text-left">Nombre del producto</b-th>
              <b-th class="text-center" style="width:8%">Cantidad</b-th>
              <b-th class="text-center" style="width:13%">Precio unitario</b-th>
              <b-th class="text-center" style="width:8%" v-if="esAdministrador()">Descuento</b-th>
              <b-th class="text-center" style="width:8%" v-if="esSupervisor()">Descuento</b-th>
              <b-th class="text-center" style="width:8%" v-if="esVendedor()"></b-th>  
              <b-th class="text-center" style="width:13%">Total USD</b-th>
              <b-th class="text-center" style="width:16%">Total MXN</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-for="(row, index) in rows" v-bind:key="index">
            <b-tr v-if="row.product!=null">
              <b-td v-if="products[row.product].productName != null">
                {{products[row.product].productName}} Marca:
                <label
                  v-if="products[row.product].brand == null"
                >N/A</label>
                <label
                  v-if="products[row.product].brand != null"
                >{{products[row.product].brand.Nombre}}</label>
              </b-td>
              <b-td>
                <b-form-input
                  type="number"
                  v-model.number="row.quantity"
                  size="sm"
                  step="any"
                  min="1"
                  @change="getTotalPrice(index)" 
                  v-on:keyup="getTotalPrice(index)"
                ></b-form-input>
              </b-td>
              <b-td
                v-if="products[row.product].priceWDisc > 0 && products[row.product].priceWDisc!==products[row.product].price"
              >
                <span style="text-decoration:line-through; color:#444 !important; font-size:16px">{{(products[row.product].price).toFixed(2)}}</span>
                <span style=""> {{(products[row.product].priceWDisc).toFixed(2)}}</span>
                 
              </b-td>
              <b-td
                v-else
                style="  font-size: 18px; color: #444 !important;"
              >{{(products[row.product].price).toFixed(2)}}</b-td>
              <b-td class="text-center" v-if="esAdministrador() || esSupervisor()">
                <b-button variant="primary" size="sm" @click="showDiscRow(index)">Agregar</b-button>
              </b-td>
              <b-td class="text-center" v-if="!esAdministrador() && !esSupervisor()"> 
              </b-td>
              <b-td>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(row.price)}}</b-td>
              <b-td>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format((row.pricePesos))}}</b-td>
            </b-tr>
            <b-tr v-if="row.product!=null && row.showDisc == true">
              <b-td colspan="4" class="text-right">Descuento por producto:</b-td>
              <b-td colspan="1">
                <b-input
                  type="number"
                  size="sm"
                  min="0"
                  v-model="row.disc"
                  @change="getTotalPrice(index)"
                  v-on:keypress="verifyDiscount($event)"
                  v-on:keyup="getTotalPrice(index)"
                  required
                ></b-input>
              </b-td>
              <b-td colspan="1">
                <b-input
                  type="number"
                  size="sm"
                  min="0"
                  v-model="row.discPesos"
                  @change="getTotalPrice(index)"
                  v-on:keypress="verifyDiscount($event)"
                  v-on:keyup="getTotalPrice(index)"
                  required
                ></b-input>
              </b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot :bordered="false">
            <b-tr>
              <b-td variant="secondary" colspan="4" class="text-right">Subtotal:</b-td>
              <b-td variant="secondary">
                <b>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(subtotal)}} USD</b>
              </b-td>
              <b-td variant="secondary">
                <b>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(subtotalPesos)}} MXN</b>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td variant="secondary" colspan="4" class="text-right">IVA:</b-td>
              <b-td variant="secondary">
                <b>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(totalIVA)}} USD</b>
              </b-td>
              <b-td variant="secondary">
                <b>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(totalIVAPesos)}} MXN</b>
              </b-td>
            </b-tr>
            <b-tr v-if="esSupervisor()">
              <b-td variant="secondary" colspan="4" class="text-right">Descuento:</b-td>
              <b-td variant="secondary">
                <b-form-input
                  type="number"
                  size="sm"
                  min="0"
                  v-model="discount"
                  @change="sendDiscount"
                  v-on:keypress="verifyDiscount($event)"
                  v-on:keyup="sendDiscount"
                  required
                ></b-form-input>
              </b-td> 
              <b-td variant="secondary">
                <b-form-input
                  type="number"
                  size="sm"
                  min="0"
                  v-model="discountPesos"
                  @change="sendDiscountPesos"
                  v-on:keypress="verifyDiscount($event)"
                  v-on:keyup="sendDiscountPesos"
                  required
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr v-if="esAdministrador()">
              <b-td variant="secondary" colspan="4" class="text-right">Descuento:</b-td>
              <b-td variant="secondary">
                <b-form-input
                  type="number"
                  size="sm"
                  min="0"
                  v-model="discount"
                  @change="sendDiscount"
                  v-on:keypress="verifyDiscount($event)"
                  v-on:keyup="sendDiscount"
                  required
                ></b-form-input>
              </b-td> 
              <b-td variant="secondary">
                <b-form-input
                  type="number"
                  size="sm"
                  min="0"
                  v-model="discountPesos"
                  @change="sendDiscountPesos"
                  v-on:keypress="verifyDiscount($event)"
                  v-on:keyup="sendDiscountPesos"
                  required
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td variant="secondary" colspan="4" class="text-right">Total:</b-td>
              <b-td variant="secondary">
                <b>{{Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(total)}} USD</b>
              </b-td>
              <b-td variant="secondary">
                <b>{{Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(totalPesos)}} MXN</b>
              </b-td>
            </b-tr>
            
            
          </b-tfoot>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "tablaProductos",
  props: {
    rows: Array,
    products: Array,
    total: Number,
    totalPesos: Number,
    subtotal: Number,
    subtotalPesos: Number,
    totalIVA: Number,
    totalIVAPesos: Number,
    disc: Number,
    discPesos: Number,
    cuota: Number,
    totalMasCuota: Number,
    cuotaPesos: Number,
    totalMasCuotaPesos: Number,
    getTotalPrice: Function,
    getTotal: Function,
    verifyQuantity: Function
  },
  data() {
    return {
      discount: this.disc,
      discountPesos: this.discPesos
    };
  },
  created() {},
  methods: {
    sendDiscount(event) {
      this.$emit("getDiscountValue", this.discount);
    },
    sendDiscountPesos(event) {
      this.$emit("getDiscountPesosValue", this.discountPesos);
    },
    showDiscRow(index) {
      this.rows[index].showDisc = !this.rows[index].showDisc;
    },
    verifyDiscount(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if ((charCode > 47 && charCode < 58) || charCode === 46) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    getCompany() {
      axios.get();
    }
  }
};
</script>

<style>
table.table {
  color: #444 !important;
}
</style>